import EarningsModal from "../EarningsModal";
import TutorialModal from "../TutorialModal";

const EarningsWrapModal = ({ earnings, onClose }) => {
  // Check if we can show custom modal for specific level
  let customModalId = '';
  if (typeof earnings.completedLevel === 'number') {
    const levesWithCustomModal = {
      0: 'achievement-1',
      3: 'achievement-2',
      4: 'achievement-3',
      5: 'achievement-4',
    };
    customModalId = levesWithCustomModal[earnings.completedLevel] || '';
  }

  if (customModalId) {
    return <TutorialModal onClose={onClose} earnings={earnings} tutorialId={customModalId} />
  } else {
    return <EarningsModal onClose={onClose} earnings={earnings}/>
  }
};

export default EarningsWrapModal;
